export default __webpack_public_path__ + "static/media/business_blue.c962a560.svg";